module.exports = __webpack_public_path__ + "static/media/t05ru.9c92454e.pdf";